module.exports = __webpack_public_path__ + "assets/fonts/arrow-down.72199389.svg";